import styled from 'styled-components';

interface RowProps {
    reverse?: boolean;
}

export const HomeWrapper = styled.div`
    background:#f8fbf9;
`
export const SectionRow = styled.div<RowProps>`
    display: flex;
    flex-direction: ${props => props.reverse ? 'row-reverse' : 'row'};
    align-items: center;
    justify-content: space-between;
    padding: 22px 88px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0px 8px 25px 0px #0000000D;
    margin-bottom: 30px;

    @media (max-width: 768px) {
        flex-direction: column;
        padding: 22px;
    }
`

export const SectionContent = styled.div`
    padding: 0 44px;

    h2 {
        margin-bottom: 24px;
        font-weight: 700;
        font-size: 32px;
        color: #212529;
    }

    p {
        color: #333333;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.5px;
        font-family: sans-serif;

    }

    button {
        margin-left: auto;
        display: block;
    }
    .step-title {
        color: #299B85;
        font-weight: 700;
        font-size: 17px;
        line-height: 24px;
    }

    @media (max-width: 768px) {
        padding-left: 0;
        padding-right: 0;

        h2 {
            font-size: 22px;
        }

        button {
            margin-bottom: 15px;
            width: 100%;
        }
    }
`

export const SectionImg = styled.div`
    flex-shrink: 0;
    flex-basis: 25%;
    img {
        max-height: 200px;
    }

    @media (max-width: 768px) {
        max-width: 100%;
    }
`

export const HomepageTopSection = styled.div`
    display: flex;
    align-items: center; 
    justify-content: space-between;

    img {
        max-width: 580px;
    }

    @media (max-width: 767px) {
        flex-direction: column;

        img {
            max-width: 100%;
        }
    }
`

export const HomepageTopSectionMain = styled.div`
    max-width: 600px;
    margin: 0 auto;
    padding: 44px 0px;

    h1 {
        font-size: 54px;
        font-weight: 700;
        line-height: 1.1;
        margin-bottom: 20px;
    }

    p {
        font-size: 17px;
        color: #333333;
        line-height: 25px;
        letter-spacing: 0.5px;
    }

    .home-p {
        font-family: sans-serif;
    }

    @media (max-width: 991px) {
        h1 {
            font-size: 36px;
            font-weight: 700;
            line-height: 44px;
            margin-bottom: 24px;
        }

        p {
            margin-bottom: 24px;
        }
    }

    @media (max-width: 768px) {
        width: 100%;
    }
`
export const HomepageTopSectionButtons = styled.div`
    button {
        text-transform: uppercase;
        margin-right: 20px;
    }
    
`

export const ProgramSection = styled.div`
    padding-top: 120px;
    padding-bottom: 120px;
    h4 {
        font-size: 24px;
        color: #299B85;
        text-align: center;
        font-weight: 700;
        margin-bottom: 18px
    }

    h3 {
        color: #212529;
        font-size: 40px;
        text-align: center;
        font-weight: 700;
        line-height: 50px;
        width: 50%;
        margin: 0 auto 18px; 
    }

    @media (max-width: 768px) {
        padding-top: 80px;
        padding-bottom: 80px;

        h4 {
            font-size: 20px;
            font-weight: 700;
            line-height: 30px;
        }
        h3 {
            width: 100%;
            font-size: 28px;
            line-height: 36px;
        }
    }
`

export const Divider = styled.div`
    width: 80px;
    height: 3px;
    background: #6ECFB2;
    content: "";
    display: block;
    margin: 0 auto 60px;

    @media (max-width: 768px) {
        margin-bottom: 48px;
    }
`

export const JoinSection = styled.div`
    background: radial-gradient(89.48% 373.44% at 92.67% 89.43%, #005242 32.71%, #006451 100%);
`

export const JoinContent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 44px 0;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`

export const JoinLabel = styled.div`
    flex-basis: 30%;
    padding-top: 20px;
    h3 {
        font-weight: 700;
        font-size: 40px;
        color: #ffffff;
        margin-bottom: 25px;
    }
    
    p {
        color: #ffffff;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.2px;
    }

    @media (max-width: 768px) {
        h3 {
            font-size: 28px;
        }
    }
`

export const JoinForm = styled.div`
    flex: 1;
    padding-left: 80px;

    .form-label {
        color: #ffffff;
    }
    input, textarea, select {
        border: 1px solid #6ECFB2;
        background: #6ECFB21A;
        color: #ffffff;
        border-radius: 8px;

    }

    input: focus, textarea: focus, select: focus  {
        background: #6ECFB21A;
        border-color: #6ECFB2;
        color: #ffffff;
    }

    select option {
        color: #333333
    }
    .form-control::placeholder {
        color: #FFFFFFCC;
    }

    button {
        margin-left: auto;
        display: block;
    }

    @media (max-width: 768px) {
        padding-left: 0;

        button {
            width: 100%;
            margin-left: 0;
            margin-top: 50px;
        }

        .form-group {
            margin: 10px 0 !important;
        }
    }
`

export const FaqSection = styled.div`
    padding: 0 0 120px 0;
    h3 {
        text-align: center;
        font-size: 40px;
        line-height: 50px;
        margin-bottom: 25px;
        color: #212529;
    }

    .accordion-title {
        color: #212529;
        font-weight: 700;
        font-size: 24px;
    }
    
    @media (max-width: 768px) {
        padding: 0 0 80px 0;

        h3 {
            font-size: 28px;
            line-height: 36px;
            font-weight: 700;
        }
        .accordion-title {
            font-size: 20px;
            line-height: 24px;
            font-weight: 700;
        }

        .MuiAccordion-root {
            margin-bottom: 20px;
        }
    }
`

export const SolutionSection = styled.div`
    padding: 120px 0;
    h3 {
        text-align: center;
        font-size: 40px;
        line-height: 50px;
        margin-bottom: 25px;
        color: #212529;
    }

    p {
        text-align: center;
    }
    .solution-p {
        margin-bottom: 64px
    }

    @media (max-width: 768px) {
        padding: 60px 0;
        h3 {
            font-size: 28px;
            font-weight: 700;
            line-height: 36px;
            text-align: left;
        }
        .solution-p {
            margin-bottom: 48px;
            text-align: left;
        }
    }
`

export const SolutionCards = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 4%;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`

export const SolutionCard = styled.div`
    flex-basis:0 1 48%;
    box-shadow: 0px 8px 20px 0px #0000001A;
    box-sizing: border-box;
    background: #FFFFFF;
    padding-top: 20px;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    
    img {
        max-width: 100%;
    }
    .logo, p {
        padding: 0 20px;
    }
    .logo {
        height: 50px;
        margin-bottom: 10px;
    }
    .share {
        height: 43px;
    }

    .solution-bg {
        border-radius: 0 0 12px 12px;
    }

    p {
        text-align: left;
    }
    &:hover {
        box-shadow: 0 10px 20px rgba(33, 150, 243, 0.3);
        transform: translateY(-5px);
    }

    @media (max-width: 768px) {
        margin-bottom: 20px;

        .logo {
            height: 39px;
            margin-bottom: 24px;
        }
    }
`

export const SolutionCardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 20px;
    margin-bottom: 10px;

    h5 {
        color: #299B85;
    }

    button {
        text-transform: none;
        padding: 10px 27px !important;
    }

    @media (max-width: 768px) {
        h5 {
            font-size: 18px;
        }
        .logo {
            height: 39px;
            margin-bottom: 24px;
        }

        .share {
            height: 28px;
        }

        button {
            padding: 6px 8px;
            font-size: 14px;
            line-height: 18px;
            white-space: nowrap;
            height: 100%;
            margin-left: 50px;
        }
    }
`